<template>
    <eg-button
        variant="eg-blue-outline-exclusive"
        @click="exportQuotationPdf()"
        v-if="isParticipating"
        :loading="loadingPDF"
    >
        <span
            ><span class="icon-pdf-space"><i class="fas fa-download"></i></span> Exportar Cotação</span
        >
    </eg-button>
</template>

<script>
import { exportQuotationPdf } from '@/services/api/statistics';
export default {
    props: {
        isParticipating: Boolean,
        competition: Object
    },
    name: 'export-pdf',
    data: () => ({
        isDesktop: true,
        loadingPDF: false
    }),
    mounted() {
        const vue = this;
        window.addEventListener('resize', () => {
            vue.isDesktop = !(window.innerWidth <= 768);
        });
        vue.isDesktop = !(window.innerWidth <= 768);
    },
    methods: {
        async exportQuotationPdf() {
            this.loadingPDF = true;
            try {
                const data = await exportQuotationPdf(this.competition.id);
                const file = new Blob([data], { type: 'application/pdf' });
                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);
            } catch (error) {
                console.error(error);
            } finally {
                this.loadingPDF = false;
            }
        }
    }
};
</script>

<style>
.icon-pdf-space {
    margin-right: 10px;
}
</style>
